import { useDebounce } from "@visiblethread/react-components";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setZoom } from "slices/documentViewer/documentViewerSlice";
import { selectDocumentBaseWidth } from "slices/documentViewer/selectors";

import { SCROLLBAR_DITHER } from "../constants";

let animationFrameId;

const useSetZoomByContainer = (containerRef) => {
  const dispatch = useDispatch();
  const baseWidth = useSelector(selectDocumentBaseWidth);

  const onResizeContainer = () => {
    const containerEl = containerRef.current;
    const rect = containerEl?.getBoundingClientRect();
    const containerWidth = (rect?.width || baseWidth) - SCROLLBAR_DITHER;

    if (animationFrameId) {
      cancelAnimationFrame(animationFrameId);
    }

    animationFrameId = requestAnimationFrame(() => {
      dispatch(setZoom(containerWidth / baseWidth));
    });
  };
  const onResizeDebounced = useDebounce(onResizeContainer, 500);

  useEffect(() => {
    if (!containerRef?.current) {
      return;
    }

    const observer = new ResizeObserver(onResizeDebounced);
    observer.observe(containerRef?.current);
    onResizeContainer();

    return () => {
      observer.disconnect();
      cancelAnimationFrame(animationFrameId);
    };
  }, []);
};

export default useSetZoomByContainer;
